import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import 'wicg-inert';

window.addEventListener('DOMContentLoaded', (event) => {
	const modalBtn = document.querySelectorAll('[data-modal]');
	const modalClose = document.querySelectorAll('[data-modal-close]');
	const page = document.querySelector('#page');
	const hash = window.location.hash;

	modalBtn.forEach(function (elem) {
		elem.addEventListener('click', function (event) {
			const modalName = this.getAttribute('data-modal');
			const modal = document.querySelector('#' + modalName);

			page.inert = true; // disable accessibility tabbing through page content
			modal.classList.add('show'); // show modal

			disableBodyScroll(modal.querySelector('.content')); // disable body scrolling while modal is open
		});
	});

	modalClose.forEach(function (elem) {
		elem.addEventListener('click', function (event) {
			event.preventDefault();

			const modal = this.closest('.modal');
			const modalName = modal.getAttribute('id');
			const modalBtn = document.querySelector(
				"[data-modal='" + modalName + "']"
			);

			page.inert = false; // enable accessibility tabbing through page content
			modal.classList.remove('show'); // hide modal
			history.pushState('', document.title, window.location.pathname); // remove hash from URL

			// refocus button used to open modal
			if (modalBtn) {
				modalBtn.focus();
			}

			clearAllBodyScrollLocks(); // enable body scrolling
		});
	});

	document.addEventListener('keyup', (event) => {
		event = event || window.event;

		// ESC PRESSED
		if (event.keyCode == 27) {
			const modal = document.querySelector('.modal.show');

			if (modal) {
				const modalName = modal.getAttribute('id');
				const modalBtn = document.querySelector(
					"[data-modal='" + modalName + "']"
				);

				page.inert = false;
				modal.classList.remove('show');
				history.pushState('', document.title, window.location.pathname); // remove hash from URL

				// refocus button used to open modal
				if (modalBtn) {
					modalBtn.focus();
				}

				clearAllBodyScrollLocks();
			}
		}
	});

	// check for modals hash in URL then show modal
	if (hash) {
		const modal = document.querySelector(hash);

		if (modal && modal.classList.contains('modal')) {
			page.inert = true;
			modal.classList.add('show');

			disableBodyScroll(modal.querySelector('.content'));
		}
	}

	// detect # change in URL and then open modal
	window.addEventListener(
		'hashchange',
		(event) => {
			if (window.location.hash) {
				const modal = document.querySelector(window.location.hash);

				if (modal && modal.classList.contains('modal')) {
					page.inert = true;
					modal.classList.add('show');

					disableBodyScroll(modal.querySelector('.content'));
				}
			}
		},
		false
	);
});
